import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Importa os estilos globais que criámos
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
